import { BiDonateHeart } from "react-icons/bi";
import { IoPeopleOutline } from "react-icons/io5";
import { TbBuildingSkyscraper } from "react-icons/tb";

let accountTypes = [
  {
    value: "INDIVIDUAL",
    label: "Volunteer",
    icon: <IoPeopleOutline />,
    image: "/vector-graphics/account-types/volunteer.jpg",
    description: "Connect with NGO & participate in social work",
  },
  {
    value: "NGO",
    label: "NGO",
    icon: <BiDonateHeart />,
    image: "/vector-graphics/account-types/ngo.jpg",
    description: "Connect with companies & volunteers",
  },
  {
    value: "COMPANY",
    label: "Company",
    icon: <TbBuildingSkyscraper />,
    image: "/vector-graphics/account-types/company.jpg",

    description: "Connect with volunteers & NGOs",
  },
];

export default accountTypes;
